import React from 'react'
import MarketUpper from './marketUpper'
import MarketButtons from './marketButtons'
import MarketTable from './marketTable'

export default function Market() {
  return (
    <>
      <MarketUpper />
      <MarketButtons />
      <MarketTable />
    </>
  )
}
